<ng-template #exitButton>
	<!-- Zur übersichtsseite -->
	<app-splitbutton class="back-button" [elements]="[backToParticipantSplitButton]"></app-splitbutton>
</ng-template>

<ng-container *ngIf="workflowItem$ | async as workflowItem">
	<div class="toolbar">
		<ng-container [ngTemplateOutlet]="exitButton"></ng-container>

		<!-- Randomisierung zurücksetzen -->
		<ng-container *ngIf="isFinished$ | async">
			<app-splitbutton class="reset-randomization-button" *appIfPermission="'workflow:undorandomize'" [elements]="[resetRandomizationButton]"></app-splitbutton>
		</ng-container>
	</div>

	<div class="content compact-view">
		<nz-card
			[nzTitle]="'workflow.randomization' | translate"
			class="print-no-header print-no-padding print-no-border print-no-shadow mb-3"
		>
			<div class="card-body">
				<p *ngIf="allocatedGroup$ | async; else pendingTemplate">{{ 'workflow.randomization.allocated' | translate: {'group': allocatedGroup$ | async} }}</p>
			</div>
			<i-feather *ngIf="allocatedGroup$ | async" class="icon check-circle" name="check-circle"></i-feather>
		</nz-card>

		<div class="toolbar bottomButtons">
			<ng-container [ngTemplateOutlet]="exitButton"></ng-container>

			<app-badge-icon [appWorkflowItemStatus]="workflowItem.id"></app-badge-icon>

			<!-- Randomisierung ausführen -->
			<ng-container *ngIf="isRandomizable$ | async">
				<app-splitbutton class="randomization-button" *appIfPermission="'workflow:randomize'" [elements]="[randomizationButton]"></app-splitbutton>
			</ng-container>
		</div>
	</div>
</ng-container>

<workflow-projektsidebar class="sidebar" [currentParticipant]="participant$ | async">
</workflow-projektsidebar>

<ng-template #pendingTemplate>
	<p>{{ 'workflow.randomization.pending' | translate }}</p>
</ng-template>

<ng-template appModal let-close #confirmRandomization="appModal">
	<nz-modal
		[nzMaskClosable]="false"
		nzVisible
		nzTitle="{{ 'actions.randomization.start' | translate }}"
		(nzOnOk)="close(true)"
		(nzOnCancel)="close(false)"
		nzOkText="{{'actions.randomization.start' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
	>
		{{ 'message.confirm.randomization.start' | translate }}
	</nz-modal>
</ng-template>

<ng-template appModal let-close #resetRandomization="appModal">
	<nz-modal
		[nzMaskClosable]="false"
		nzVisible
		nzTitle="{{ 'actions.randomization.reset' | translate }}"
		(nzOnOk)="close(true)"
		(nzOnCancel)="close(false)"
		nzOkText="{{'actions.randomization.reset' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
	>
		{{ 'message.confirm.randomization.reset' | translate }}
	</nz-modal>
</ng-template>
